// TODO: Add correct icon file imports when they are in inst icons
// import { MultipleChoiceIcon } from '@instructure/ui-icons'
// import { MultipleAnswerIcon } from '@instructure/ui-icons'
// import { TrueOrFalseIcon } from '@instructure/ui-icons'
// import { MatchingIcon } from '@instructure/ui-icons'
// import { OrderingIcon } from '@instructure/ui-icons'
// import { FillBlankIcon } from '@instructure/ui-icons'
// import { EssayIcon } from '@instructure/ui-icons'
import { IconPlusLine } from '@instructure/ui-icons';
import t from '@instructure/quiz-i18n/es/format-message';
var interactionTypesIconDictionary = function interactionTypesIconDictionary(intType) {
  return {
    // TODO: Uncomment when we have the icons imported
    // 'choice': MultipleChoiceIcon,
    // 'multi-answer': MultipleAnswerIcon,
    // 'true-false': TrueOrFalseIcon,
    // 'matching': MatchingIcon,
    // 'ordering': OrderingIcon,
    // 'fill-blank': FillBlankIcon,
    // 'essay': EssayIcon
  }[intType.slug] || IconPlusLine;
};
export var interactionTypesNameDictionary = function interactionTypesNameDictionary(intType) {
  return {
    categorization: t('Categorization'),
    choice: t('Multiple Choice'),
    essay: t('Essay'),
    'file-upload': t('File Upload'),
    'fill-blank': t('Fill in the Blank'),
    formula: t('Formula'),
    'hot-spot': t('Hot Spot'),
    matching: t('Matching'),
    'multi-answer': t('Multiple Answer'),
    numeric: t('Numeric'),
    ordering: t('Ordering'),
    'rich-fill-blank': t('Fill in the Blank'),
    'true-false': t('True or False')
  }[intType.slug] || intType.name;
};
export var interactionTypeMetadata = function interactionTypeMetadata(intType) {
  return {
    icon: interactionTypesIconDictionary(intType),
    name: interactionTypesNameDictionary(intType)
  };
};